import moment from "moment";
import { BudgetPeriod } from "@/services/cloudchipr.api";
import { getFQuarterByStartMonth } from "@/components/common/date-range-picker/utils/preDefinedRanges/getQuarterlyPreDefinedRange";

export const getPlannedBudgetDateLabel = (
  period: BudgetPeriod,
  startDate: string,
  index: number,
  quarterStartMonth?: number,
) => {
  let label = "";

  if (period === "monthly") {
    label = moment(startDate).add(index, "months").format("MMM YYYY");
  }

  if (period === "quarterly") {
    const date = moment(startDate).add(index * 3, "months");
    const startMonth = date.month(); // 0-based
    const year = date.year();

    const result = getFQuarterByStartMonth(startMonth + 1, quarterStartMonth);

    label = `Q${result.quarter} ${year}`;
  }

  return label;
};
